import React from 'react';
import {Link} from 'react-router-dom';
import axios from 'axios';
import '../config.js';
import { theme, getFormattedDate, getFormattedTime, downloadReceipt } from '../services/helper.js';
import { alertService } from '../services/alert.service.js';

function ReceiptListItem(props) {

  return(
        <tr>
          <td>{props.info.receipt_id}</td>
          {props.type == 'all' && 
            <td width="15%">
              <Link to={"/client/"+props.info.client+"/receipt"} className={'btn btn-icon-split mr-2 btn-'+theme()}>
                <span className="icon text-white-50">
                  <i className="fas fa-link"></i>
                </span>
                <span className="text">{props.info.salutation} {props.info.first_name} {props.info.middle_name} {props.info.last_name}</span>
              </Link>
            </td>
          }
          <td width="30%">{props.info.description}</td>
          <td>{props.info.mode}</td>
          <td>{props.info.amount}</td>
          <td>{props.info.currency}</td>
          <td>{getFormattedDate(props.info.updation_date)}<br/>{getFormattedTime(props.info.updation_date)}</td>
          <td>
            <Link to={"/receipt/"+props.info.receipt_id+"/"+props.type} className={'btn btn-icon-split mr-2 btn-'+theme()}>
              <span className="icon text-white-50">
                <i className="fas fa-edit"></i>
              </span>
            </Link>
            <button className={'btn btn-icon-split btn-'+theme()} onClick={() => downloadReceipt(axios, props.info.receipt_id, props.info.invoice)}>
              <span className="icon text-white-50">
                <i className="fas fa-download"></i>
              </span>
            </button>
          </td>
        </tr>
  )
}

export default ReceiptListItem;